import React, { useState, useEffect } from 'react';
import Answer from '../Answer';
import Header from '../Header';
import Question from '../Question';

const CourseAutocomplete = ({ currentQuestion, storeAnswers, removeAnswer, answers }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [courses, setCourses] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [subQuestions, setSubQuestions] = useState(false);
    const [courseLink, setCourseLink] = useState('https://www.ncl.ac.uk/undergraduate/degrees/');
    const [courseData, setCourseData] = useState([]);

    useEffect(() => {
        fetch('https://nu-partners-api.herokuapp.com/api/v1/course/list')
            .then((response) => {
                if (response.status !== 200) {
                    console.error(`Looks like there was a problem. Status Code: ${response.status}`);

                    return;
                }

                response.json().then((data) => {
                    if (data.rowCount > 0 && data.rows) {
                        setCourseData(data.rows);
                    }
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const subQuestionLocal = answers.hasOwnProperty('subQuestion') ? answers.subQuestion : null;

    const fetchSearchData = () => {
        if (courseData.length > 0) {
            let courseList = courseData;

            if (searchTerm.length > 0) {
                courseList = courseList.filter((course) =>
                    course.name.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }

            if (courseList.length === 0) {
                setErrorMessage(
                    'Can’t find the course you’re interest in?<br />Get in touch with the PARTNERS team to discuss this'
                );
                setCourses(null);

                return;
            }

            setCourses(courseList);
            setErrorMessage('');
        } else {
            setCourses(null);
            setErrorMessage(
                'Can’t find the course you’re interest in?<br />Get in touch with the PARTNERS team to discuss this'
            );
        }
    };

    const onHandleSearchClick = () => {
        fetchSearchData();
    };

    const handleResultClick = (course) => {
        setSearchTerm(course.name);
        setSubQuestions(true);
        setCourses(null);
        setErrorMessage('');
        setCourseLink(course.url);
    };

    const onHandleSearchTextChange = (event) => {
        removeAnswer(currentQuestion);
        setSubQuestions(false);
        setSearchTerm(event.target.value);
        setCourses(null);

        if (event.target.value.length >= 3) {
            fetchSearchData();
        }
    };

    const handleOnKeyPressed = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            //13 is the enter keycode
            fetchSearchData();
        }
    };

    return (
        <>
            <div className='searchWrapper long'>
                <input
                    className='searchText'
                    type='text'
                    value={searchTerm}
                    onKeyUp={handleOnKeyPressed}
                    onChange={onHandleSearchTextChange}
                />
                <button className='searchTextIcon' onClick={onHandleSearchClick} />
                {errorMessage && (
                    <p className='searchMessage error' dangerouslySetInnerHTML={{ __html: errorMessage }} />
                )}
                {courses && (
                    <div className='searchResults'>
                        {courses.map((course) => (
                            <button key={course.id} onClick={() => handleResultClick(course)}>
                                {course.name}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {subQuestionLocal && subQuestions && (
                <>
                    <a className='entryRequirement' href={courseLink} target='_blank' rel='noreferrer'>
                        Click to view entry requirements
                    </a>
                    <Header title='' heading={subQuestionLocal.heading} progressStage={3} />
                    <Question heading={subQuestionLocal.question} description={subQuestionLocal.description} />
                    <Answer
                        type='radio'
                        answers={subQuestionLocal.answers}
                        storeAnswer={storeAnswers}
                        currentQuestion={currentQuestion}
                        selectedCourse={subQuestions ? searchTerm : ''}
                    />
                </>
            )}
        </>
    );
};

export default CourseAutocomplete;
